import { Component } from '@angular/core';

@Component({
  selector: 'app-cards1-examples-5',
  templateUrl: './cards1-examples-5.component.html'
})
export class Cards1Examples5Component {}
